@if (isConnecting) {
  <app-loading></app-loading>
} @else {
  <p>Something went wrong while connecting to Xero.</p>
}
